module.exports = function() {
  return new Worker(__webpack_public_path__ + "f78c5ecc3faf488499e6.worker.js");
};